import { render, staticRenderFns } from "./OnlyMobile.vue?vue&type=template&id=549a7d6c"
import script from "./OnlyMobile.vue?vue&type=script&lang=js"
export * from "./OnlyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports